import { render, staticRenderFns } from "./MainPromo.vue?vue&type=template&id=5662bd58&"
import script from "./MainPromo.vue?vue&type=script&lang=js&"
export * from "./MainPromo.vue?vue&type=script&lang=js&"
import style0 from "./MainPromo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports